(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonial-video-carousel"] && !Shopify.designMode) return;
  try {
    
function initTestimonialVideoCarousel(root) {
  if (!root || root.dataset.tvcInitialized === 'true') return;
  root.dataset.tvcInitialized = 'true';

  const swiperEl = root.querySelector('.tvc-carousel.swiper');
  if (!swiperEl || typeof Swiper === 'undefined') return;

  const scrollbar = swiperEl.parentElement.querySelector('.swiper-scrollbar');
  const nextEl = root.querySelector('.swiper-button-next-testi');
  const prevEl = root.querySelector('.swiper-button-prev-testi');
  const pagination = root.querySelector('.swiper-pagination');

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 1.9,
    spaceBetween: 10,
    observer: true,
    observeParents: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    scrollbar: {
        el: scrollbar,
        draggable: true,
        snapOnRelease: false,
        dragSize: 50,
        enabled: true,
    },
    navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
    },
    breakpoints: {
      600: { slidesPerView: 2.2, spaceBetween: 20 },
      900: { slidesPerView: 3, spaceBetween: 24 },
      1200: { slidesPerView: 4, spaceBetween: 24 }
    }
  });

  const mediaWrappers = root.querySelectorAll('.tvc-card-media');

  const pauseAllExcept = (activeVideo) => {
    mediaWrappers.forEach((wrapper) => {
      const vid = wrapper.querySelector('.tvc-video');
      if (vid !== activeVideo && !vid.paused) {
        vid.pause();
      }
    });
  };

  mediaWrappers.forEach((wrapper) => {
    const video = wrapper.querySelector('.tvc-video');
    const playIcon = wrapper.querySelector('.tvc-icon-play');
    const pauseIcon = wrapper.querySelector('.tvc-icon-pause');

    const setPlayingState = (playing) => {
      wrapper.classList.toggle('is-playing', playing);
      if (playIcon) playIcon.style.display = playing ? 'none' : 'block';
      if (pauseIcon) pauseIcon.style.display = playing ? 'block' : 'none';
    };

    const togglePlayback = () => {
      if (video.paused) {
        pauseAllExcept(video);
        video.play();
        setPlayingState(true);
      } else {
        video.pause();
        setPlayingState(false);
      }
    };

    wrapper.addEventListener('click', togglePlayback);
    wrapper.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        togglePlayback();
      }
    });

    video.addEventListener('play', () => setPlayingState(true));
    video.addEventListener('pause', () => setPlayingState(false));
    video.addEventListener('ended', () => setPlayingState(false));

    // Reflect the initial autoplay state on the icon.
    if (!video.paused) setPlayingState(true);
  });
}

function initAllTestimonialVideoCarousels() {
  document.querySelectorAll('.tvc-section').forEach(initTestimonialVideoCarousel);
}

document.addEventListener('DOMContentLoaded', initAllTestimonialVideoCarousels);


document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('.tvc-section');
  initTestimonialVideoCarousel(root);
});

  } catch(e) { console.error(e); }
})();
})();
